import React from 'react';

import { IconProps } from './types';

export const BarnIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 511.999 511.999"
    fill="#909090"
    ref={forwardedRef}
    {...props}
  >
    <g>
      <g>
        <polygon points="174.599,370.413 174.599,490.787 234.786,430.601 		" />
      </g>
    </g>
    <g>
      <g>
        <polygon points="255.999,451.814 195.812,511.999 316.187,511.999 		" />
      </g>
    </g>
    <g>
      <g>
        <polygon points="195.812,349.2 255.999,409.388 316.187,349.2 		" />
      </g>
    </g>
    <g>
      <g>
        <polygon points="277.212,430.601 337.399,490.787 337.399,370.413 		" />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M510.857,250.259L440.272,79.847c-1.522-3.675-4.442-6.596-8.118-8.117L261.739,1.142c-3.676-1.523-7.805-1.523-11.48,0
			L79.845,71.73c-3.676,1.521-6.596,4.442-8.118,8.117L1.141,250.257c-1.917,4.629-1.396,9.908,1.387,14.074
			S9.99,270.997,15,270.997h33.199v226.002c0,8.285,6.716,15,15,15h81.4V334.2c0-8.284,6.716-15,15-15h192.8c8.284,0,15,6.716,15,15
			v177.799h81.4c8.284,0,15-6.715,15-15v-226h33.2c5.01,0,9.688-2.5,12.472-6.666C512.254,260.167,512.774,254.888,510.857,250.259z
            M319.198,207.8c0,8.284-6.716,15-15,15H207.8c-8.284,0-15-6.716-15-15v-96.4c0-8.283,6.716-15,15-15h96.398
			c8.284,0,15,6.717,15,15V207.8z"
        />
      </g>
    </g>
    <g>
      <g>
        <rect x="222.799" y="126.399" width="66.4" height="66.4" />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
));
BarnIcon.displayName = 'BarnIcon';

export default BarnIcon;
